import styled from "styled-components";
import { defaultTheme } from "styles/theme/default";

export const DeliveryItem = styled.div`
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid ${defaultTheme.colors["white-box"]};
  border-radius: 8px;
  background: ${defaultTheme.colors["white-100"]};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DeliveryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;

  strong {
    color: ${defaultTheme.colors.black};
    font-size: 0.95rem;
  }
`;

export const DeliveryPrimaryInfo = styled.div`
  min-width: 0;

  > strong {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const DeliveryMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
  color: ${defaultTheme.colors["gray-300"]};
  font-size: 0.72rem;

  span + span::before {
    content: "•";
    margin-right: 6px;
    color: ${defaultTheme.colors["gray-200"]};
  }
`;

export const DeliveryStatus = styled.span<{ kind: "success" | "failed" | "pending" }>`
  flex: 0 0 auto;
  align-self: flex-start;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  color: ${({ kind }) => {
    if (kind === "success") {
      return "#047A3A";
    }

    if (kind === "failed") {
      return defaultTheme.colors.danger;
    }

    return defaultTheme.colors["base-dark"];
  }};
  background: ${({ kind }) => {
    if (kind === "success") {
      return "#E5F8EC";
    }

    if (kind === "failed") {
      return "#FDE8EB";
    }

    return defaultTheme.colors["base-light"];
  }};
`;

export const DeliveryDetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.9fr 0.8fr 0.7fr;
  gap: 8px 14px;
  margin-top: 12px;

  @media screen and (max-width: 820px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 12px;
  }
`;

export const DetailItem = styled.div<{ highlight?: boolean }>`
  min-width: 0;

  span {
    display: block;
    color: ${defaultTheme.colors["gray-300"]};
    font-size: 0.7rem;
    line-height: 1.2;
  }

  strong {
    display: block;
    margin-top: 4px;
    color: ${({ highlight }) =>
      highlight ? defaultTheme.colors["base-dark"] : defaultTheme.colors.black};
    font-size: ${({ highlight }) => (highlight ? "1rem" : "0.86rem")};
    font-weight: ${({ highlight }) => (highlight ? 700 : 600)};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const DeliveryBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 12px;
`;

export const OrderFlag = styled.span<{ kind: "first" | "complaint" }>`
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  color: ${({ kind }) =>
    kind === "first" ? defaultTheme.colors["base-dark"] : defaultTheme.colors.danger};
  background: ${({ kind }) =>
    kind === "first" ? defaultTheme.colors["base-light"] : "#FDE8EB"};
`;
